export default __webpack_public_path__ + "static/media/Screen2.5340efb1.png";